document.addEventListener('click', async (event) => {
  const button = event.target.closest('.wt-warranty-add');
  if (!button || button.disabled) return;
  event.preventDefault();
  const error = button.closest('.wt-cart-extra').querySelector('.wt-warranty-error');
  error.hidden = true;
  button.disabled = true;
  button.textContent = 'Adding…';
  try {
    const drawer = document.querySelector('cart-drawer');
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST', headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({items: [{id: Number(button.dataset.variant), quantity: Number(button.dataset.quantity), parent_line_key: button.dataset.parent}], sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname})
    });
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || 'Could not add the warranty. Please try again.');
    if (location.pathname.endsWith('/cart') || !drawer) location.reload();
    else { drawer.renderContents(data); if (typeof publish === 'function') publish(PUB_SUB_EVENTS.cartUpdate, {source: 'warranty', cartData: data}); }
  } catch (e) {
    error.textContent = e.message; error.hidden = false;
    button.disabled = false; button.textContent = 'Add';
  }
});
